<template>
  <b-form-row>
    <b-modal size="xl" button-size="sm" ref="finder" hide-footer :id="this.id" :title="title">
      <ProcessoCompraList :produto='produto' @close='hideModal' :prefix="updatedPrefix" @onSelectItem="processoCompraSelect"
        @processCreated="emitProcessCreated" />
    </b-modal>

    <lg-form-input-finder :value="computedValue" @input="updateValue" fieldDescription="descricao"
      :showClearButton="false" invalidFeedback="Processo de Compra deve ser informado!" description=""
      @handleClean="handleClean" :disabled="disabled">
      <template #prepend v-if="!disabled">
        <b-button @click="show" class="btn-input-finder" pressed>
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import ProcessoCompraList from "../../modules/patrimonio/processo-compra/ProcessoCompraList.vue"

export default {
  components: { LgFormInputFinder, ProcessoCompraList },
  props: {
    id: String,
    prefix: Array,
    value: String,
    disabled: {
      type: Boolean,
      default: false
    },
    produto: {
      type: Object,
      default: () => ({}),
      Required: true
    }
  },
  data() {
    return {
      internalValue: this.value || {},
    }
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.internalValue
      },
      set(newValue) {
        this.internalValue = newValue
      },
    },
    updatedPrefix() {
      return [...this.prefix, "Processo de Compra"]
    },
    title() {
      return this.updatedPrefix.join(" > ")
    },
  },
  methods: {
    show() {
      this.$bvModal.show(this.id)
    },
    emitProcessCreated() {
      this.$emit('processCreated')
    },
    hideModal() {
      this.$bvModal.hide(this.id)
    },
    updateValue(newValue) {
      this.computedValue = newValue
      this.$emit('input', newValue)
    },
    handleClean() {
      this.computedValue = ""
      this.$emit('input', "")
    },
    processoCompraSelect(item) {
      this.computedValue = item
      this.$emit('input', item)
      this.hideModal()
    },
  },
}
</script>
